/* Roasterland coffee finder ("Build your morning").
   RLFinder.init(root, {scroller, pre}) runs one finder; RLFinder.open(pre) shows it in a full-screen modal
   from any page. Links to the finder page open the modal instead of navigating. */
(function () {
  function init(root, opts) {
  opts = opts || {};
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var toTop = function (smooth) {
    if (opts.scroller) opts.scroller.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    else if (smooth) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  var data = JSON.parse(root.querySelector('[data-finder-data]').textContent);
  var form = root.querySelector('[data-form]');
  var steps = [].slice.call(root.querySelectorAll('.ritual__step'));
  var next = root.querySelector('[data-next]'), back = root.querySelector('[data-back]');
  var result = root.querySelector('[data-result]');
  var cur = 0, done = false;
  var $ = function (s) { return root.querySelector(s); };
  var val = function (n) { var el = form.querySelector('[name=' + n + ']:checked') || form.querySelector('input[name=' + n + '][type=range]'); return el ? el.value : ''; };
  var labelOf = function (n) { var el = form.querySelector('[name=' + n + ']:checked'); return el ? el.dataset.label : ''; };
  var words = function () { return [].map.call(form.querySelectorAll('[name=word]:checked'), function (i) { return i.value; }); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var WORD = { strength: ['', 'Gentle', 'Easy', 'Balanced', 'Strong', 'Rocket fuel'], milk: ['Black', 'A splash', 'Flat white', 'Latte'], sugar: ['None', 'A little', 'Sweet'] };
  var ROASTS = ['', 'Light', 'Medium-light', 'Medium', 'Medium-dark', 'Dark'];
  var FLAV = { juicy: 'fruit', fruity: 'fruit', wild: 'fruit', floral: 'floral', clean: 'floral', bright: 'citrus', chocolatey: 'choc', nutty: 'choc', cozy: 'choc', sweet: 'sweet', smooth: 'sweet', bold: 'spice' };
  var BREW = { pour: 'pour', chemex: 'pour', espresso: 'espresso', moka: 'espresso', press: 'press', aero: 'press', drip: 'drip', cold: 'cold' };
  var BASE = { pour: 1.6, chemex: 1.5, aero: 2.4, drip: 2.8, espresso: 3.6, moka: 3.8, press: 3.4, cold: 3.8 };

  function model() {
    var w = words(), gear = val('gear'), st = +val('strength'), milk = +val('milk');
    var count = function (list) { return w.filter(function (x) { return list.indexOf(x) > -1; }).length; };
    var fruity = count(['bright', 'juicy', 'floral', 'wild', 'fruity']), cozy = count(['cozy', 'nutty', 'chocolatey', 'smooth', 'bold', 'sweet']);
    var roast = Math.max(1, Math.min(5, (BASE[gear] || 2.8) + (st - 3) * 0.4 + milk * 0.3 + (cozy - fruity) * 0.25));
    var adv = Math.max(1, Math.min(5, Math.round(2.5 + count(['wild']) * 1.5 + count(['juicy', 'fruity', 'floral', 'bright']) * 0.5 - count(['cozy', 'smooth', 'chocolatey', 'nutty']) * 0.4)));
    var flavors = []; w.forEach(function (x) { if (FLAV[x] && flavors.indexOf(FLAV[x]) < 0) flavors.push(FLAV[x]); });
    return { w: w, gear: gear, st: st, milk: milk, sugar: +val('sugar'), roast: roast, adv: adv, flavors: flavors };
  }

  function paint() {
    var m = model();
    var dark = [196, 150, 110], light = [43, 26, 16], cream = [222, 196, 160];
    var k = (m.st - 1) / 4, mk = m.milk / 3 * 0.75;
    $('[data-cup]').style.background = 'rgb(' + dark.map(function (c, i) { return Math.round((c + (light[i] - c) * k) * (1 - mk) + cream[i] * mk); }).join(',') + ')';
    ['strength', 'milk', 'sugar'].forEach(function (n) { $('[data-out=' + n + ']').textContent = WORD[n][+val(n)]; });
    var g = form.querySelector('[name=gear]:checked');
    $('[data-tipbox]').innerHTML = g ? '<b>' + esc(g.dataset.label) + '</b> · ' + esc(g.dataset.tip) + ' · our recipe: ' + esc(g.dataset.recipe) : '';
    $('[data-wordcount]').textContent = m.w.length + ' of 3 picked';
    var reach = done ? 4 : cur;
    var chips = [['When', labelOf('time'), 0], ['Gear', labelOf('gear'), 1], ['Cup', WORD.strength[m.st] + ', ' + WORD.milk[m.milk].toLowerCase(), 2], ['Taste', m.w.join(', '), 3]];
    $('[data-summary]').innerHTML = chips.map(function (c) { var on = reach >= c[2] && c[1]; return '<li class="' + (on ? 'on' : '') + '">' + c[0] + ': ' + (on ? esc(c[1]) : '…') + '</li>'; }).join('');
    [].forEach.call(root.querySelectorAll('[data-dots] i'), function (d, i) { d.className = i <= reach ? 'on' : ''; });
    root.classList.toggle('is-done', done);
    next.disabled = cur === 3 && m.w.length === 0;
  }

  function go(i) {
    cur = i;
    steps.forEach(function (s, k) { s.hidden = k !== i; });
    back.hidden = i === 0;
    next.textContent = i === 3 ? 'Build my ritual' : 'Next';
    paint();
    toTop(window.innerWidth < 750);
  }

  form.addEventListener('input', paint);
  form.addEventListener('change', function (e) {
    if (e.target.name === 'word' && words().length > 3) e.target.checked = false;
    paint();
  });
  next.addEventListener('click', function () { if (cur < 3) go(cur + 1); else finish(); });
  back.addEventListener('click', function () { if (cur > 0) go(cur - 1); });
  $('[data-restart]').addEventListener('click', function () {
    form.reset(); done = false; result.hidden = true; form.hidden = false; go(0); toTop(true);
  });

  function card(x, big, m) {
    var c = x.c, pct = Math.max(50, Math.min(99, Math.round(x.s)));
    var cup = c.g ? ' · ' + money(Math.round(c.p * 15 / c.g)) + '/cup' : '';
    var buy = c.one === 1
      ? '<form method="post" action="/cart/add"><input type="hidden" name="id" value="' + c.v + '"><input type="hidden" name="quantity" value="1"><button class="btn btn--sm" type="submit">Add · ' + money(c.p) + '</button></form>'
      : '<a class="btn btn--sm" href="' + c.u + '">Choose size · ' + money(c.p) + '</a>';
    return '<article class="match' + (big ? ' match--big' : '') + '">' +
      '<a class="match__media" href="' + c.u + '">' + (c.i ? '<img src="' + c.i + '" alt="" loading="lazy">' : '') + (big ? '<span class="match__pct">' + pct + '% match</span>' : '') + '</a>' +
      '<div class="match__body"><p class="match__roaster">' + esc(c.r) + (c.o ? ' · ' + esc(c.o) : '') + '</p>' +
      '<a class="match__title" href="' + c.u + '">' + esc(c.t) + '</a>' +
      (c.n ? '<p class="match__notes">' + esc(c.n) + '</p>' : '') +
      '<p class="score-line"><span class="score-line__adv"><span class="dots" aria-hidden="true">' + [1, 2, 3, 4, 5].map(function (k) { return '<i' + (k <= c.a ? ' class="on"' : '') + '></i>'; }).join('') + '</span>Adventure ' + c.a + '/5</span><span class="score-line__cup">' + (c.ro ? esc(c.ro) + ' roast' : '') + cup + '</span></p>' +
      (big && x.why.length ? '<ul class="match__why">' + x.why.slice(0, 3).map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>' : '') +
      '<div class="match__buy">' + buy + '</div></div></article>';
  }

  function finish() {
    var m = model();
    var answers = { brew: BREW[m.gear] || 'any', milk: m.milk > 0 ? 'milk' : 'black', flavors: m.flavors, adv: m.adv, budget: 999,
      roast: m.roast, ritual: { time: val('time'), gear: m.gear, strength: m.st, milk: m.milk, sugar: m.sugar, words: m.w } };
    if (window.RLProfile) window.RLProfile.seed(answers);
    var scored = window.RLProfile ? window.RLProfile.rank(data) : data.map(function (c) { return { c: c, s: 50, why: [] }; });
    var top = [], seen = {};
    for (var i = 0; i < scored.length && top.length < 3; i++) { if (seen[scored[i].c.r]) continue; seen[scored[i].c.r] = 1; top.push(scored[i]); }
    var more = scored.filter(function (x) { return top.indexOf(x) < 0; }).slice(0, 6);
    var g = form.querySelector('[name=gear]:checked');
    $('[data-line]').textContent = labelOf('time') + ', ' + labelOf('gear').toLowerCase() + ', ' + m.w.join(', ') + '.';
    $('[data-f=recipe]').textContent = g ? g.dataset.recipe : '';
    $('[data-f=roast]').textContent = ROASTS[Math.round(m.roast)];
    $('[data-f=adv]').textContent = m.adv + ' of 5';
    $('[data-f=gear]').textContent = labelOf('gear') + (m.milk ? ', ' + WORD.milk[m.milk].toLowerCase() : ', black');
    $('[data-f=time]').textContent = labelOf('time').toLowerCase();
    $('[data-top]').innerHTML = top.map(function (x) { return card(x, true, m); }).join('');
    $('[data-more]').innerHTML = more.map(function (x) { return card(x, false, m); }).join('');
    $('[data-start]').href = top[0] ? top[0].c.u + (top[0].c.u.indexOf('?') > -1 ? '&' : '?') + 'ritual=1' : '/collections/all';
    done = true; form.hidden = true; result.hidden = false; paint();
    toTop(true);
    if (window.gtag) gtag('event', 'finder_complete', { finder: 'ritual', gear: m.gear, time: val('time'), strength: m.st, milk: m.milk, adventure: m.adv, words: m.w.join(',') });
  }

  // Answers carried over from the menu mini-game (?pre=choc,bright)
  var PRE = { choc: 'chocolatey', fruit: 'juicy', bright: 'bright', cozy: 'cozy' };
  root.__applyPre = function (pre) {
    if (!pre || done) return;
    pre.split(',').forEach(function (k) { var el = PRE[k] && form.querySelector('input[name=word][value=' + PRE[k] + ']'); if (el && !el.checked && words().length < 3) el.checked = true; });
    paint();
  };
  go(0);
  root.__applyPre(opts.pre || (location.search.match(/[?&]pre=([a-z,]+)/) || [])[1]);
  }

  var modal, modalBody, loaded = false, opener = null;
  function build() {
    modal = document.createElement('div');
    modal.className = 'fmodal'; modal.hidden = true;
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Find my coffee');
    modal.innerHTML = '<div class="fmodal__panel"><button type="button" class="fmodal__close" aria-label="Close" data-fmodal-close><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button><div class="fmodal__body" data-fmodal-body><p class="fmodal__loading">Warming the cup…</p></div></div>';
    document.body.appendChild(modal);
    modalBody = modal.querySelector('[data-fmodal-body]');
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-fmodal-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    window.addEventListener('popstate', function () { if (!modal.hidden) close(true); });
  }
  function open(pre, href) {
    if (!modal) build();
    opener = document.activeElement;
    var drawerClose = document.querySelector('#MenuDrawer:not([hidden]) [data-drawer-close]'); if (drawerClose) drawerClose.click();
    modal.hidden = false; document.documentElement.classList.add('fmodal-open');
    try { history.pushState({ rlFinder: 1 }, '', '#find-my-coffee'); } catch (e) {}
    modal.querySelector('[data-fmodal-close]').focus();
    if (window.gtag) gtag('event', 'finder_open', { where: 'modal' });
    if (loaded) { var r = modalBody.querySelector('[data-ritual]'); if (r && pre && r.__applyPre) r.__applyPre(pre); return; }
    fetch(href || '/pages/find-your-coffee', { credentials: 'same-origin' }).then(function (res) { return res.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = doc.querySelector('[data-ritual]');
      if (!sec) throw new Error('no finder');
      modalBody.innerHTML = ''; modalBody.appendChild(document.importNode(sec, true));
      loaded = true;
      init(modalBody.querySelector('[data-ritual]'), { scroller: modalBody, pre: pre });
    }).catch(function () { window.location.href = href || '/pages/find-your-coffee'; });
  }
  function close(fromPop) {
    if (!modal || modal.hidden) return;
    modal.hidden = true; document.documentElement.classList.remove('fmodal-open');
    if (!fromPop && history.state && history.state.rlFinder) { try { history.back(); } catch (e) {} }
    if (opener && opener.focus) opener.focus();
  }

  window.RLFinder = { init: init, open: open, close: close };

  // The finder page itself
  var page = document.querySelector('[data-ritual]');
  if (page) init(page);

  // Any link to the finder opens the modal instead (not on the finder page, not with modifier keys)
  if (!page) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href*="/pages/find-your-coffee"]');
      if (!a || a.target === '_blank') return;
      if (a.hasAttribute('data-fab') && !a.classList.contains('is-open')) return; // first tap only expands the floating cup
      e.preventDefault();
      var pre = (a.getAttribute('href').match(/[?&]pre=([a-z,]+)/) || [])[1];
      open(pre, a.href.split('#')[0]);
    });
    if (location.hash === '#find-my-coffee') open();
  }
})();
